import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { FlexRow } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { switchBackToAdmin } from 'reducks/auth/operations'
import { State } from 'index'
import { getAuthShopRef, getStoreRef } from 'reducks/auth/selectors'
import { BlueTag } from 'components/Tag'
import { closeSubHeaderAction } from 'reducks/nav/actions'

const AdminSwitchCard: FC = () => {
  const dispatch = useDispatch()
  const shopRef = useSelector((state: State) => getAuthShopRef(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))

  return (
    <div className={styles.row__inner}>
      <FlexRow justifyContent={'between'}>
        <p>スーパー管理者</p>
        {typeof storeRef === 'undefined' && typeof shopRef === 'undefined' ? (
          <BlueTag shape={'ellipse'} size={'large'} tagName={'操作中'} />
        ) : (
          <a
            className={`${text.color_blue_main} ${text.font_xxsmall}`}
            role={'button'}
            onClick={() => {
              dispatch(switchBackToAdmin())
              dispatch(closeSubHeaderAction())
            }}
          >
            切り替える
          </a>
        )}
      </FlexRow>
    </div>
  )
}

export default AdminSwitchCard
